import BaseValidator from '~/composer/composer/lib/validation/BaseValidator';
import ValidationFail from '~/composer/composer/lib/validation/ValidationFail';
import ValidationResult from '~/composer/composer/lib/validation/ValidationResult';
import ValidationSuccess from '~/composer/composer/lib/validation/ValidationSuccess';
import { gbpChannelDataValidation } from '~/composer/composer/lib/validation/utils/gbpChannelDataValidation';

export default class GoogleBusinessValidator extends BaseValidator {
  protected validateAttachmentOrText(): ValidationResult {
    if (
      this.draft.updateType === 'offer' ||
      this.draft.updateType === 'event'
    ) {
      return new ValidationSuccess();
    }

    return super.validateAttachmentOrText();
  }

  protected validateGBPTitle() {
    return gbpChannelDataValidation.validateGBPTitle(
      this.draft.updateType,
      this.draft.channelData?.googlebusiness
    );
  }

  protected validateGBPCouponCode() {
    return gbpChannelDataValidation.validateGBPCouponCode(
      this.draft.updateType,
      this.draft.channelData?.googlebusiness
    );
  }

  protected validateGBPDateTime() {
    return gbpChannelDataValidation.validateGBPDateTime(
      this.draft.updateType,
      this.draft.channelData?.googlebusiness
    );
  }

  protected validateGBPCTA() {
    return gbpChannelDataValidation.validateGBPCTA(
      this.draft.updateType,
      this.draft.channelData?.googlebusiness
    );
  }

  protected validateGBPRedeemLink() {
    return gbpChannelDataValidation.validateGBPRedeemLink(
      this.draft.updateType,
      this.draft.channelData?.googlebusiness
    );
  }

  protected validateGBPTerms() {
    return gbpChannelDataValidation.validateGBPTerms(
      this.draft.updateType,
      this.draft.channelData?.googlebusiness
    );
  }

  protected validateDraft(): ValidationResult[] {
    if (
      this.draft.updateType === 'whats_new' &&
      (this.draft.hasText() || this.draft.hasAttachment()) &&
      !this.shouldValidateVideo()
    ) {
      return [];
    }

    const videoValidationResults = this.shouldValidateVideo()
      ? this.validateVideo()
      : new ValidationSuccess();

    return [
      this.validateAttachmentOrText(),
      videoValidationResults,
      this.validateGBPTitle(),
    ].filter((message) => typeof message !== typeof ValidationFail);
  }

  protected validateForChannel(): ValidationResult[] {
    return [
      this.validateGBPTitle(),
      this.validateGBPCouponCode(),
      this.validateGBPDateTime(),
      this.validateGBPCTA(),
      this.validateGBPRedeemLink(),
      this.validateGBPTerms(),
    ];
  }
}
